/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  EqualizationCreateDataRequest
} from '../../model/equalizationCreateDataRequest'
import type {
  FundFamilySubEventData
} from '../../model/fundFamilySubEventData'
import type {
  GenericTableData
} from '../../model/genericTableData'
import type {
  IsCancelCorrectEqualizationAvailableResponseData
} from '../../model/isCancelCorrectEqualizationAvailableResponseData'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Create a capital activity equalization
 */
export const equalizationCreate = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    equalizationCreateDataRequest: EqualizationCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilySubEventData>(
      {url: `/fund-family/${fundFamilyId}/equalization/${fundFamilyEventId}/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: equalizationCreateDataRequest
    },
      options);
    }
  


export const getEqualizationCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof equalizationCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: EqualizationCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof equalizationCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: EqualizationCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof equalizationCreate>>, {fundFamilyId: string;fundFamilyEventId: string;data: EqualizationCreateDataRequest}> = (props) => {
          const {fundFamilyId,fundFamilyEventId,data} = props ?? {};

          return  equalizationCreate(fundFamilyId,fundFamilyEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EqualizationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof equalizationCreate>>>
    export type EqualizationCreateMutationBody = EqualizationCreateDataRequest
    export type EqualizationCreateMutationError = unknown

    export const useEqualizationCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof equalizationCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: EqualizationCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getEqualizationCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Check if a cancel correct equalization is available.
 */
export const isCancelCorrectEqualizationAvailableRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<IsCancelCorrectEqualizationAvailableResponseData>(
      {url: `/fund-family/${fundFamilyId}/equalization/${fundFamilyEventId}/is-cancel-correct-equalization-available/`, method: 'GET', signal
    },
      options);
    }
  

export const getIsCancelCorrectEqualizationAvailableRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/equalization/${fundFamilyEventId}/is-cancel-correct-equalization-available/`] as const;
    }

    
export const getIsCancelCorrectEqualizationAvailableRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof isCancelCorrectEqualizationAvailableRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof isCancelCorrectEqualizationAvailableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIsCancelCorrectEqualizationAvailableRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof isCancelCorrectEqualizationAvailableRetrieve>>> = ({ signal }) => isCancelCorrectEqualizationAvailableRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof isCancelCorrectEqualizationAvailableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type IsCancelCorrectEqualizationAvailableRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof isCancelCorrectEqualizationAvailableRetrieve>>>
export type IsCancelCorrectEqualizationAvailableRetrieveQueryError = unknown

export const useIsCancelCorrectEqualizationAvailableRetrieve = <TData = Awaited<ReturnType<typeof isCancelCorrectEqualizationAvailableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof isCancelCorrectEqualizationAvailableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getIsCancelCorrectEqualizationAvailableRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getIsCancelCorrectEqualizationAvailableRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof isCancelCorrectEqualizationAvailableRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof isCancelCorrectEqualizationAvailableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIsCancelCorrectEqualizationAvailableRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof isCancelCorrectEqualizationAvailableRetrieve>>> = ({ signal }) => isCancelCorrectEqualizationAvailableRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof isCancelCorrectEqualizationAvailableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type IsCancelCorrectEqualizationAvailableRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof isCancelCorrectEqualizationAvailableRetrieve>>>
export type IsCancelCorrectEqualizationAvailableRetrieveSuspenseQueryError = unknown

export const useIsCancelCorrectEqualizationAvailableRetrieveSuspense = <TData = Awaited<ReturnType<typeof isCancelCorrectEqualizationAvailableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof isCancelCorrectEqualizationAvailableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getIsCancelCorrectEqualizationAvailableRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getIsCancelCorrectEqualizationAvailableRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getIsCancelCorrectEqualizationAvailableRetrieveQueryKey(fundFamilyId,fundFamilyEventId),
              queryFn: () => isCancelCorrectEqualizationAvailableRetrieve(fundFamilyId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get an equalization view.
 */
export const equalizationRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/equalization/fund-family-event/${fundFamilyEventId}/fund-family-sub-event/${fundFamilySubEventId}`, method: 'GET', signal
    },
      options);
    }
  

export const getEqualizationRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/equalization/fund-family-event/${fundFamilyEventId}/fund-family-sub-event/${fundFamilySubEventId}`] as const;
    }

    
export const getEqualizationRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof equalizationRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equalizationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEqualizationRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof equalizationRetrieve>>> = ({ signal }) => equalizationRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equalizationRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type EqualizationRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof equalizationRetrieve>>>
export type EqualizationRetrieveQueryError = unknown

export const useEqualizationRetrieve = <TData = Awaited<ReturnType<typeof equalizationRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equalizationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getEqualizationRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getEqualizationRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof equalizationRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof equalizationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEqualizationRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof equalizationRetrieve>>> = ({ signal }) => equalizationRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof equalizationRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type EqualizationRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof equalizationRetrieve>>>
export type EqualizationRetrieveSuspenseQueryError = unknown

export const useEqualizationRetrieveSuspense = <TData = Awaited<ReturnType<typeof equalizationRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof equalizationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getEqualizationRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getEqualizationRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string,fundFamilySubEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId,fundFamilySubEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId && fundFamilySubEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getEqualizationRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId),
              queryFn: () => equalizationRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId),
            }).then(() => null);
          }
          return null;
        });
      